var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import { styleBlock } from "../styleBlock";
import iconIndicatorBlue from "../assets/icons/Indicator Blue.svg";
import { RawDropdown } from "../index";
const MessagesWidget = (_a) => {
    var { className, headerRow, messages, noMessagesLabel, newUnreadMessageAlt } = _a, inputProps = __rest(_a, ["className", "headerRow", "messages", "noMessagesLabel", "newUnreadMessageAlt"]);
    const b = styleBlock("messages-widget");
    function renderMessage(message, index) {
        const isLast = messages ? index == messages.length - 1 : false;
        return (React.createElement(RawDropdown.Item, { onClick: message.onClick, key: index },
            React.createElement(Row, { noGutters: true, className: b("row", { unread: message.isUnread }).toString() },
                React.createElement(Col, { xs: 12 },
                    React.createElement("div", { className: b("datetime") }, message.date)),
                React.createElement(Col, { xs: 12 },
                    message.isUnread && React.createElement("img", { src: iconIndicatorBlue, className: b("indicator"), alt: newUnreadMessageAlt }),
                    React.createElement("span", { className: b("message") }, message.title))),
            !isLast && React.createElement(RawDropdown.Divider, null)));
    }
    return (React.createElement(RawDropdown, { className: b.toString() + " " + className },
        headerRow,
        React.createElement("div", { className: b("container").toString() }, messages && messages.length > 0 ? (messages.map((message, index) => renderMessage(message, index))) : (React.createElement("div", { className: "text-muted" },
            React.createElement("hr", null),
            noMessagesLabel)))));
};
export default MessagesWidget;
//# sourceMappingURL=index.js.map